import React from 'react';

export default () => (
  <svg focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.481a8.519 8.519 0 1 0 0 17.038A8.519 8.519 0 0 0 12 3.48zm-.617 6.544c.706 0 1.286.538 1.352 1.227l.006.13v3.087c0 .243.174.444.405.486l.089.008h.617a.74.74 0 0 1 .1 1.475l-.1.006h-.617a1.975 1.975 0 0 1-1.97-1.827l-.006-.148v-2.963h-.494a.74.74 0 0 1-.1-1.475l.1-.006h.618zm.308-3.087a1.05 1.05 0 1 1 0 2.099 1.05 1.05 0 0 1 0-2.099z" />
  </svg>
);
